import storage from '@/services/storage';

const toBeDeletedKeys = [
  'default_auth_token',
  'ads-satisfaction-survey-hyperlink',
  'ads-satisfaction-survey-hyperlink-2',
];

export default function removeUnusedStorageData() {
  toBeDeletedKeys.forEach(key => storage.remove(key));
}
